<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-12 20:33:38
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/modifynickname/components/InputClearn/index.vue
-->
<template>
  <div>
    <van-field
      v-model="value1"
      right-icon="clear"
      :placeholder="placeholder"
      @click-right-icon="clear"
      @blur="blur"
    />
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "请输入昵称"
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      value1: ""
    };
  },
  mounted() {
    this.value1 = this.value;
  },
  methods: {
    clear() {
      this.value1 = "";
      this.$emit("inputValue", this.value1);
    },
    blur() {
      this.$emit("inputValue", this.value1);
    }
  }
};
</script>
<style lang="less" scoped>
.in_clearn {
  background: #fff;
}
::v-deep .van-field__right-icon {
  color: rgb(191, 194, 202) !important;
}
</style>
